import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms'

export const markFormGroupDirty = (formGroup: UntypedFormGroup) => {
  Object.keys(formGroup?.controls)?.forEach((key) => {
    switch (formGroup.get(key).constructor.name) {
      case 'FormGroup':
        markFormGroupDirty(formGroup.get(key) as UntypedFormGroup)
        break
      case 'FormArray':
        markArrayDirty(formGroup.get(key) as UntypedFormArray)
        break
      case 'FormControl':
        markControlDirty(formGroup.get(key) as UntypedFormControl)
        break
    }
  })
}
const markArrayDirty = (formArray: UntypedFormArray) => {
  formArray?.controls?.forEach((control) => {
    switch (control.constructor.name) {
      case 'FormGroup':
        markFormGroupDirty(control as UntypedFormGroup)
        break
      case 'FormArray':
        markArrayDirty(control as UntypedFormArray)
        break
      case 'FormControl':
        markControlDirty(control as UntypedFormControl)
        break
    }
  })
}
const markControlDirty = (formControl: UntypedFormControl) => {
  formControl.markAsDirty()
}
